type StepKey = "throw" | "trim" | "attach_handle" | "glaze" | string;

const STORE = "mudoTimeProfiles";
type ProfileKey = string;
type Profile = { samples: number[]; median: number };

function load(): Record<ProfileKey, Profile> {
  try { return JSON.parse(localStorage.getItem(STORE) || "{}"); } catch { return {}; }
}
function save(db: Record<ProfileKey, Profile>) { localStorage.setItem(STORE, JSON.stringify(db)); }

export function updateWithActuals(productType: string | null, step: StepKey, minutes: number) {
  if (!productType) return;
  const key = `${productType}|${step}`;
  const db = load();
  const p = db[key] || { samples: [], median: 0 };
  p.samples = [minutes, ...p.samples].slice(0, 100);
  const sorted = [...p.samples].sort((a, b) => a - b);
  p.median = sorted.length ? sorted[Math.floor(sorted.length / 2)] : minutes;
  db[key] = p;
  save(db);
}

export function getLearnedMinutes(productType: string | null, step: StepKey): number | null {
  if (!productType) return null;
  const db = load();
  const p = db[`${productType}|${step}`];
  return p?.median ?? null;
}
